export default __webpack_public_path__ + "static/award_3-76dab97bcf459c425df816ea5330e410.svg";